import validate from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/middleware/auth.global.js";
import oolojaconfiguracoes_45global from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/middleware/oolojaconfiguracoes.global.js";
import permissoescomponent_45global from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/middleware/permissoescomponent.global.js";
import manifest_45route_45rule from "/home/firethewall/Projetos/projeto_OO/OO-Administrador/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  oolojaconfiguracoes_45global,
  permissoescomponent_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  isdev: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/middleware/isdev.js"),
  iserp: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/middleware/iserp.js"),
  sockets: () => import("/home/firethewall/Projetos/projeto_OO/OO-Administrador/middleware/sockets.js")
}